import {Service} from '@s-ui/domain'

/**
 * @class
 * @implements Service
 */
export class GetPendingPtaService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Service} deps.cookieService
   * @param {Service} deps.getCurrentUserService
   * @param {Service} deps.httpService
   * @param {Service} deps.zeroValueService
   */

  constructor({cookieService, getCurrentUserService, httpService, zeroValueService}) {
    super()
    this._cookieService = cookieService
    this._getCurrentUserService = getCurrentUserService
    this._httpService = httpService
    this._zeroValueService = zeroValueService
  }

  /**
   * JavaScript Chain of Responsibility pattern with Promises.
   * @see https://bumbu.github.io/javascript-chain-of-responsibility-pattern-with-promises/
   * @return {Promise<Number>}
   */
  execute = async () => {
    const pendingPtaVO = await this._cookieService
      .execute()
      .catch(async () => {
        const userEntity = await this._getCurrentUserService.execute()
        if (!userEntity) return this._zeroValueService.execute()
        return this._httpService.execute({userEntity})
      })
      .catch(() => this._zeroValueService.execute())

    return pendingPtaVO
  }
}
